import React, { useState } from "react";
import { Card, Collapse, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faChevronDown, faChevronUp, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import AddVersionCategoryModal from "../UpdateVersionCategory/AddVersionCategoryModal";

const UnAssignedCategoryPage = ({
  sortedUnassignedByParent,
  ogmpCategories,
  expandedParentCategories,
  toggleParentCategory,
  viewOnly,
  hasOgmpCategories,
  technologies,
  groupVersionId,
  tenantName,
  env,
  handleEnvChange,
  currentTenant
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedParentName, setSelectedParentName] = useState(null);

  const handleOpenModal = (category, parentName) => {
    setSelectedCategory(category);
    setSelectedParentName(parentName);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCategory(null);
    setSelectedParentName(null);
  };

  return (
    <div className="unassigned-section">
      {hasOgmpCategories ? (
        <h4 className="my-2">
          <strong>Un-assigned OGMP Source Categories</strong>
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id="username-tooltip" className="text-start">
                You can create new ogmp source categories on Catalyst, under company admin.
              </Tooltip>
            }
          >
            <span style={{ cursor: "pointer", marginLeft: "5px" }}>
              <FontAwesomeIcon icon={faInfoCircle} className="text-primary" style={{ fontSize: "16px" }} />
            </span>
          </OverlayTrigger>
        </h4>
      ) : (
        <h5 className="mt-5">No OGMP source categories found for this tenant</h5>
      )}

      {sortedUnassignedByParent?.map(([parentId, categories]) => {
        // skip this parent group if there are no unassigned categories
        if (!categories || categories.length === 0) {
          return null;
        }

        // find a parent category to get its name
        const parentCategory = ogmpCategories.find((cat) => cat.id === parentId);
        const parentName = parentCategory ? parentCategory.name : "No Parent Category";

        return (
          <Card key={`unassigned-${parentId}`} className="mt-3 w-75">
            <Card.Header
              className="d-flex justify-content-between align-items-center"
              style={{ cursor: "pointer" }}
              onClick={() => toggleParentCategory(`unassigned-${parentId}`)}
            >
              <h5 className="mb-0">
                <strong>{parentName}</strong>
              </h5>
              <FontAwesomeIcon icon={expandedParentCategories[`unassigned-${parentId}`] ? faChevronUp : faChevronDown} size="sm" />
            </Card.Header>
            <Collapse in={expandedParentCategories[`unassigned-${parentId}`] !== false}>
              <div>
                <Card.Body className="p-0">
                  <Table striped bordered hover responsive className="table-sm mb-0">
                    <thead>
                      <tr>
                        <th>Source Category</th>
                        <th style={{ width: "300px" }}>Status</th>
                        {!viewOnly && <th style={{ width: "200px" }}>Add to Group Version</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {categories?.map((category) => (
                        <tr key={category.id}>
                          <td>{category.name}</td>
                          <td>{category.status}</td>
                          {!viewOnly && (
                            <td>
                              <div className="d-flex justify-content-center">
                                <FontAwesomeIcon
                                  icon={faPlus}
                                  style={{ cursor: "pointer", color: "green", fontSize: "18px", fontWeight: "900" }}
                                  onClick={() => handleOpenModal(category, parentName)}
                                />
                              </div>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </div>
            </Collapse>
          </Card>
        );
      })}

      <AddVersionCategoryModal
        show={showModal}
        handleClose={handleCloseModal}
        category={selectedCategory}
        parentName={selectedParentName}
        groupVersionId={groupVersionId}
        technologies={technologies}
        currentTenant={currentTenant}
        tenantName={tenantName}
        env={env}
        handleEnvChange={handleEnvChange}
      />
    </div>
  );
};

export { UnAssignedCategoryPage };
